import React from 'react';
import {
  Image,
  Text,
  View,
} from 'react-native';
import {
  participants_dollars,
  Phone_number_str,
  hundred_dollars, Show_transaction_details, thirty_four_dollars, two_hundred_dollars,
  userNameSD,
} from '../../../utils/DictionaryManagementUtils';
import IconWithTextLine from './MixComponent/IconWithTextLine';
import {
  textLink_7_0, textPrimary_18_6, textPrimary_9_3, textSecondary_7_5,
} from './TextComponent/TextStyle';
import { img_tree_with_sky } from '../../../utils/ImagesManagementUtils';

//= ========================================================================

const BigParagraphWithIconLine = ({
  globJSON, withoutIconLine = false, blueStr = Show_transaction_details,
  extendStrings, withOutLink, stringButtom, isConfirmation_split, simPlatform, onlyUserDetails, price = hundred_dollars, withAddPhoto,
}) => {
  const { colors } = globJSON.configurations.theme;
  const myStyles = {
    container: {
      width: 198,
      borderRadius: globJSON.configurations.theme.radius.elements_shape_square ? 3 : 9,
      backgroundColor: colors.light_elements_color,
      paddingVertical: 9,
      paddingHorizontal: 9,
      alignSelf: 'center',
    },
    priceStrStyle: {
      fontWeight: 'bolder',
    },
    pricePerParticipantViewStyle: {
      flexDirection: 'row', alignItems: 'center',
    },
    priceViewStyle: {
      marginVertical: !onlyUserDetails && 5,
      marginBottom: onlyUserDetails && 5,
      width: 181,
      height: 1,
      borderWidth: 0.6,
      border: 'solid',
      borderColor: colors.border_light_color,
    },
    subTitleOfPrice: {
      fontSize: 9,
      color: colors.primary_font_color,
    },
    imageStyle: {
      width: 45,
      height: 45,
    },
  };
  return (
    <View
      style={myStyles.container}
    >
      <Text style={[textPrimary_9_3(globJSON, simPlatform), { fontFamily: null }]}>
        {userNameSD}
      </Text>
      <Text
        style={[textSecondary_7_5(globJSON, simPlatform), { paddingVertical: 3 }]}
      >
        {Phone_number_str}
      </Text>
      {!withoutIconLine && (
        <IconWithTextLine
          globJSON={globJSON}
          simPlatform={simPlatform}
        />
      )}
      <Text style={[textPrimary_9_3(globJSON, simPlatform), { paddingVertical: 3, fontFamily: null }]}>
        {stringButtom}
      </Text>
      {withAddPhoto
          && (
          <Image
            fadeDuration={0}
            style={myStyles.imageStyle}
            source={img_tree_with_sky}
          />
          )}
      {extendStrings && (
        <Text style={[textSecondary_7_5(globJSON, simPlatform), { paddingVertical: 1 }]}>
          {extendStrings}
        </Text>
      )}
      {!withOutLink
          && (
          <Text style={[textLink_7_0(globJSON, simPlatform), { paddingVertical: 1 }]}>
            {blueStr}
          </Text>
          )}

      <View style={myStyles.priceViewStyle} />
      {isConfirmation_split
        ? (
          <View style={myStyles.pricePerParticipantViewStyle}>
            <Text style={textPrimary_18_6(globJSON, simPlatform)}>{thirty_four_dollars}</Text>
            <Text style={myStyles.subTitleOfPrice}>
              {participants_dollars}
            </Text>
          </View>
        )
        : (
          <Text style={[textPrimary_18_6(globJSON, simPlatform), price === two_hundred_dollars && { fontWeight: 'bold' }]}>{price}</Text>
        )}
    </View>
  );
};
export default BigParagraphWithIconLine;
